import state from '../store/state.js';
// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢
const _import = require('./import-' + process.env.NODE_ENV)

function getProps (route) {
  return route.query;
}

// 系统生成路由
const routers = [
  { path: '/login', component: _import('login/index'), name: 'login', props: getProps, desc: '登录' },
  { path: '/privacy', component: _import('login/privacy'), name: 'privacy', props: getProps, desc: '隐私政策' },
  {
    path: '/',
    component: _import('login/index'),
    name: 'root'
  },
  {
    path: '/main',
    component: _import('layout/index'),
    name: 'main',
    props: getProps,
    redirect: {
      name: 'welcome'
    },
    meta: {
      title: '主页',
      showOnly: true
    },
    children: [
      {path: 'formSysUser', component: _import('upms/formSysUser/index'), name: 'formSysUser', meta: {title: '用户管理'}},
      {path: 'formSysDept', component: _import('upms/formSysDept/index'), name: 'formSysDept', meta: {title: '部门管理'}},
      {path: 'formSysRole', component: _import('upms/formSysRole/index'), name: 'formSysRole', meta: {title: '角色管理'}},
      {path: 'formSysDataPerm', component: _import('upms/formSysDataPerm/index'), name: 'formSysDataPerm', meta: {title: '数据权限管理'}},
      {path: 'formSysMenu', component: _import(state.supportColumn ? 'upms/formSysMenu/formSysColumnMenu' : 'upms/formSysMenu/index'), name: 'formSysMenu', meta: {title: '菜单列表'}},
      {path: 'formSysDict', component: _import('upms/formDictManagement/index'), name: 'formSysDict', meta: {title: '字典管理'}},
      {path: 'formSysPermCode', component: _import('upms/formSysPermCode/index'), name: 'formSysPermCode', meta: {title: '权限字管理'}},
      {path: 'formSysPerm', component: _import('upms/formSysPerm/index'), name: 'formSysPerm', meta: {title: '权限资源管理'}},
      {path: 'formSysLoginUser', component: _import('upms/formSysLoginUser/index'), name: 'formSysLoginUser', meta: {title: '在线用户'}},
      // 岗位模块路由配置
      {path: 'formSysPost', component: _import('upms/formSysPost/index'), name: 'formSysPost', meta: {title: '岗位管理'}},
      {path: 'formSysDeptPost', component: _import('upms/formSysDeptPost/index'), name: 'formSysDeptPost', props: getProps, meta: {title: '设置部门岗位'}},
      // 在线表单模块路由配置
      {path: 'formOnlineDict', component: _import('onlineForm/formOnlineDict/index'), name: 'formOnlineDict', props: getProps, meta: {title: '在线表单字典管理'}},
      {path: 'formOnlinePage', component: _import('onlineForm/formOnlinePage/index'), name: 'formOnlinePage', props: getProps, meta: {title: '在线表单管理'}},
      {path: 'onlineForm', component: _import('onlineForm/index'), name: 'onlineForm', props: getProps, meta: {title: '在线表单'}},
      // 工作流模块路由配置
      {path: 'formMessage', component: _import('workflow/formMessage/index'), name: 'formMessage', props: getProps, meta: {title: '催办消息'}},
      {path: 'formFlowCategory', component: _import('workflow/flowCategory/formFlowCategory'), name: 'formFlowCategory', props: getProps, meta: {title: '流程分类管理'}},
      {path: 'formFlowEntry', component: _import('workflow/flowEntry/formFlowEntry'), name: 'formFlowEntry', props: getProps, meta: {title: '流程设计'}},
      {path: 'formAllInstance', component: _import('workflow/taskManager/formAllInstance'), name: 'formAllInstance', props: getProps, meta: {title: '流程实例'}},
      {path: 'formMyTask', component: _import('workflow/taskManager/formMyTask'), name: 'formMyTask', props: getProps, meta: {title: '我的待办'}},
      {path: 'formMyApprovedTask', component: _import('workflow/taskManager/formMyApprovedTask'), name: 'formMyApprovedTask', props: getProps, meta: {title: '已办任务'}},
      {path: 'formMyHistoryTask', component: _import('workflow/taskManager/formMyHistoryTask'), name: 'formMyHistoryTask', props: getProps, meta: {title: '历史流程'}},
      {
        path: 'handlerFlowTask',
        component: _import('workflow/handlerFlowTask/index'),
        name: 'handlerFlowTask',
        props: getProps,
        meta: {title: '流程处理'},
        children: [
          // 静态表单路由设置
        ]
      },
      {path: 'welcome', component: _import('welcome/index'), name: 'welcome', meta: {title: '欢迎'}},
      {path: 'irrigation_works', component: _import('data_management/irrigation_works/IrrigationWorks'), name: 'irrigation_works', meta: {title: '水利工程送审情况汇总'}},
      {path: 'city_project', component: _import('data_management/city_project/CityProject'), name: 'city_project', meta: {title: '市政工程送审情况汇总'}},
      {path: 'license_management', component: _import('licence/license_management/LicenseManagement'), name: 'license_management', meta: {title: '证照管理'}},
      {path: 'license_borrowing_and_returning', component: _import('licence/license_borrowing_and_returning/LicenseBorrowingAndReturning'), name: 'license_borrowing_and_returning', meta: {title: '证照借还'}},
      {path: 'approval_of_license_borrowing_and_returning', component: _import('licence/approval_of_license_borrowing_and_returning/ApprovalOfLicenseBorrowingAndReturning'), name: 'approval_of_license_borrowing_and_returning', meta: {title: '证照借还审批'}},
      {path: 'myJob', component: _import('workflow/taskManager/myJob'), name: 'myJob', meta: {title: '我的工作'}},
      {path: 'workSearch', component: _import('workflow/taskManager/workSearch'), name: 'workSearch', meta: {title: '工作查询'}},
      {path: 'cloud_disk', component: _import('knowledge/cloud_disk/CloudDisk'), name: 'cloud_disk', meta: {title: '共享云盘'}},
      {path: 'project_licence', component: _import('licence/project_licence/projectLicence'), name: 'project_licence', meta: { title: '证照管理' } },
      {path: 'day_record', component: _import('attendance-statistics/day-record/DayRecord'), name: 'day_record', meta: { title: '日常考勤记录' } },
      {path: 'month_record', component: _import('attendance-statistics/month-record/MonthRecord'), name: 'month_record', meta: {title: '月度考勤统计'}},
      {path: 'attendance-option', component: _import('attendance-statistics/attendance-option/AttendanceOption'), name: 'attendance-option', meta: {title: '员工全年考勤配置'}},
      {path: 'abnormal_attendance', component: _import('abnormal-attendance/abnormal-attendance/AbnormalAttendance'), name: 'abnormal_attendance', meta: {title: '考勤异常'}},
      {path: 'ask_for_leave', component: _import('abnormal-attendance/ask-for-leave/AskForLeave'), name: 'ask_for_leave', meta: {title: '请假统计'}},
      {path: 'clock_in', component: _import('abnormal-attendance/clock-in/ClockIn'), name: 'clock_in', meta: {title: '忘记打卡'}},
      { path: 'work_overtime', component: _import('abnormal-attendance/work-overtime/WorkOvertime'), name: 'work_overtime', meta: { title: '加班统计' } },
      { path: 'organization', component: _import('organization/organization'), name: 'organization', meta: { title: '组织架构' } },
      { path: 'email', component: _import('email/email'), name: 'email', meta: { title: '电子邮件' } },
      { path: 'contract-management', component: _import('contract-management/ContractManagement'), name: 'contract-management', meta: { title: '合同管理(财务)' } }
    ]
  }
];

export default routers;
